const PUSH_OPEN_WINDOW_MS = 60_000;

let pending: { path: string; at: number } | null = null;

export function markPushOpen(path: string, now: number = Date.now()): void {
  pending = { path, at: now };
}

export function consumePushOpen(path: string, now: number = Date.now()): boolean {
  if (!pending || pending.path !== path) return false;
  const openedAt = pending.at;
  pending = null;
  return now - openedAt <= PUSH_OPEN_WINDOW_MS;
}
